<template>
  <div class="wrapper">
    <div class="pdf">
    <!-- <pdf :page="pageNum" :src="URL" @progress="loadedRatio = $event" @num-pages="pageTotalNum = $event" /> -->
    <commFromVuePdf :URL="URL"></commFromVuePdf>
    </div>
  </div>
</template>

<script>
import utils from '@/common/utils'
import commFromVuePdf from '@/components/comm-from-vuePdf.vue'
import {
  BusinessAuthorityGeneratePdf
} from '@/api/channel'
export default {
  components: {
    // pdf,
    commFromVuePdf
  },
  props: {},
  data() {
    return {
      URL: '',
      pageNum: 1, //当前页
      pageTotalNum: 1, //默认总页数

    }
  },
  created() { },
  mounted() {
    this.ORCode()
  },
  activated() { },
  updated() { },
  methods: {
    async ORCode(BAMID) {
      let res = await BusinessAuthorityGeneratePdf({
        bamid: BAMID
      })
      this.URL = utils.getObjectURL(res)

      // console.log(this.URL);
    },
    //上一页
    prePage() {
      let page = this.pageNum;
      page = page > 1 ? page - 1 : this.pageTotalNum;
      this.pageNum = page;
    },
    //下一页
    nextPage() {
      let page = this.pageNum;
      page = page < this.pageTotalNum ? page + 1 : 1;
      this.pageNum = page;
    },
  },
  computed: {
    iframeHeight() {
      return screen.availHeight - 166
    }
  },
  watch: {
    '$route': {
      handler(to, from) {
        console.log(to, 'to');
        this.ORCode(to.query.BAMID)
      },
      deep: true,
      immediate: true
    }
  },
}
</script>
<style scoped lang='less'>
.wrapper {
  width: 100vw;
  height: 100vh;

  
  .pdfBottom {
    width: 90%;
    margin: 0 auto;
    line-height: 50px;
  }
  .button{
    float: right;
  }
}
</style>